import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import FormError from '../../../../../Components/FormError';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { fetchProvinceData } from '../../../../../Redux/slices/defaultData';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { capitalizeFirstLetter, ErrorMessageHandler } from '../../../../../_helpers/_methods';
import updateAction from '../../updateAction';

function PhysicalLocationDetails({
  setValue,
  isEdit,
  clearErrors,
  id,
  register,
  errors,
  type = 'roster'
}) {
  const { state, actions } = useStateMachine({ updateAction });
  const dispatch = useDispatch();
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [localLevels, setLocalLevels] = useState([]);
  const local = useSelector((state) => state.local.local);
  const provinceData = useSelector((state) => state.defaultData.provinceData);

  const path = useLocation();
  let condition = path.pathname.split('/').includes('events');

  let roster = useSelector(
    (state) =>
      isEdit &&
      (type === 'roster'
        ? state.rosters.rosters.user
        : type === 'trainees_office_address'
        ? state.trainees.trainees?.office_address
        : state.trainees.trainees?.user)
  );

  useEffect(() => {
    const getProvinces = async () => {
      try {
        if (!provinceData) {
          dispatch(fetchProvinceData());
        } else {
          const tempProvince = provinceData.map((province) => ({
            label: local === 'ne' ? province.title : province.title_en,
            value: province.title
          }));
          setProvinces(tempProvince);
          // actions.updateAction({
          //   [`${id}_physical_location_details`]: {}
          // });
          // setValue(`${id}_physical_location_details.province`, null);
          // setValue(`${id}_physical_location_details.district`, null);
          // setValue(`${id}_physical_location_details.local_level`, null);
        }
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    getProvinces();
  }, [provinceData, local]);

  useEffect(() => {
    if (isEdit && roster && roster.address && roster?.address?.length) {
      setValue(`${id}_physical_location_details.ward`, roster?.address[0].ward);
      setValue(`${id}_physical_location_details.tole`, roster?.address[0].tole);
    }
    handleGetDistrict(provinces);
  }, [provinces, roster]);

  const handleGetDistrict = (provinceData = []) => {
    let ourProvince = provinceData.find(
      (province) =>
        province.value ===
        (state?.[`${id}_physical_location_details`]?.province?.value ||
          (roster && roster.address[0]?.province))
    );
    if (ourProvince) {
      setValue(`${id}_physical_location_details.province`, ourProvince);
      //reset district and local level
      actions.updateAction({
        [`${id}_physical_location_details`]: {
          ...state?.[`${id}_physical_location_details`],
          province: ourProvince
        }
      });
      getDistricts(ourProvince.value, { province: ourProvince });
    }
  };

  const getDistricts = async (province, location) => {
    try {
      const response = await fetchWrapper.get(`/district/?province=${province}&limit=50`);
      const districtsData = response.results.map((district) => ({
        label: local === 'ne' ? district.title : district.title_en,
        value: district.title
      }));
      setDistricts(districtsData);
      if (
        state?.[`${id}_physical_location_details`]?.district ||
        (roster && roster.address && roster?.address?.length)
      ) {
        let ourDistrict = districtsData.find(
          (district) =>
            district.value ===
            (state?.[`${id}_physical_location_details`]?.district.value ||
              roster.address[0]?.district)
        );
        if (ourDistrict) {
          setValue(`${id}_physical_location_details.district`, ourDistrict);
          getLocalLevel(ourDistrict.value, { ...location, district: ourDistrict });
        }
      }
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const getLocalLevel = async (district, location) => {
    try {
      const response = await fetchWrapper.get(`/local_level/?district=${district}&limit=400`);
      const localLevelData = response.results.map((local_level) => ({
        label: local === 'ne' ? local_level.title : capitalizeFirstLetter(local_level.title_en),
        value: local_level.title
      }));
      setLocalLevels(localLevelData);
      if (
        state?.[`${id}_physical_location_details`]?.local_level ||
        (roster && roster.address && roster?.address?.length)
      ) {
        let ourLocalLevel = localLevelData.find(
          (local_level) =>
            local_level.value ===
            (state?.[`${id}_physical_location_details`]?.local_level.value ||
              roster.address[0]?.municipality)
        );
        if (ourLocalLevel) {
          setValue(`${id}_physical_location_details.local_level`, ourLocalLevel);
          actions.updateAction({
            [`${id}_physical_location_details`]: {
              province: location.province,
              district: location.district,
              local_level: ourLocalLevel
            }
          });
        }
      }
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  useEffect(() => {
    setValue(
      `${id}_physical_location_details.province`,
      state?.[`${id}_physical_location_details`]?.province
    );
    setValue(
      `${id}_physical_location_details.district`,
      state?.[`${id}_physical_location_details`]?.district
    );
    setValue(
      `${id}_physical_location_details.local_level`,
      state?.[`${id}_physical_location_details`]?.local_level
    );
  }, []);

  const handleProvinceChange = (element) => {
    setValue(`${id}_physical_location_details.province`, element);
    clearErrors(`${id}_physical_location_details.province`);
    getDistricts(element.value);

    //reset district and local level
    actions.updateAction({
      [`${id}_physical_location_details`]: {
        province: element
      }
    });
    setValue(`${id}_physical_location_details.district`, null);
    setValue(`${id}_physical_location_details.local_level`, null);
  };
  const handleDistrictChange = (element) => {
    setValue(`${id}_physical_location_details.district`, element);
    clearErrors(`${id}_physical_location_details.district`);
    getLocalLevel(element.value);
    //reset local level
    actions.updateAction({
      [`${id}_physical_location_details`]: {
        ...state?.[`${id}_physical_location_details`],
        district: element,
        local_level: null
      }
    });
    setValue(`${id}_physical_location_details.local_level`, null);
  };
  const handleLocalLevelChange = (element) => {
    setValue(`${id}_physical_location_details.local_level`, element);
    clearErrors(`${id}_physical_location_details.local_level`);
    actions.updateAction({
      [`${id}_physical_location_details`]: {
        ...state?.[`${id}_physical_location_details`],
        local_level: element
      }
    });
  };
  return (
    <Row key={local}>
      <Col md="3">
        <FormattedMessage id="select_province">
          {(placeholder) => (
            <FormGroup
              key={Math.random()}
              label={<FormattedMessage id="province" />}
              id={`${id}_physical_location_details.province`}
              required={true}
              type="select"
              register={register}
              error={errors}
              errorId={`province`}
              placeholder={placeholder[0]}
              onChange={handleProvinceChange}
              defaultValue={state?.[`${id}_physical_location_details`]?.province}
              options={provinces}
            />
          )}
        </FormattedMessage>
        <FormError error={errors[`${id}_physical_location_details`]?.province} />
      </Col>
      <Col md="2" key={state?.[`${id}_physical_location_details`]?.province?.value}>
        <FormattedMessage id="select_district">
          {(placeholder) => (
            <FormGroup
              key={Math.random()}
              label={<FormattedMessage id="district" />}
              id={`${id}_physical_location_details.district`}
              type="select"
              register={register}
              errorId={`district`}
              required={true}
              error={errors}
              placeholder={placeholder[0]}
              onChange={handleDistrictChange}
              defaultValue={state?.[`${id}_physical_location_details`]?.district}
              options={districts}
            />
          )}
        </FormattedMessage>
        <FormError error={errors[`${id}_physical_location_details`]?.district} />
      </Col>
      <Col md="3" key={state?.[`${id}_physical_location_details`]?.district?.value}>
        <FormattedMessage id="select_local_level">
          {(placeholder) => (
            <FormGroup
              key={Math.random()}
              label={<FormattedMessage id="local_level" />}
              id={`${id}_physical_location_details.local_level`}
              type="select"
              register={register}
              errorId={`local_level`}
              error={errors}
              onChange={handleLocalLevelChange}
              options={localLevels}
              defaultValue={state?.[`${id}_physical_location_details`]?.local_level}
              placeholder={placeholder[0]}
              required={true}
            />
          )}
        </FormattedMessage>
        <FormError error={errors[`${id}_physical_location_details`]?.local_level} />
      </Col>
      <Col md="2">
        <FormattedMessage id="ward_placeholder">
          {(placeholder) => (
            <>
              <FormGroup
                id={`${id}_physical_location_details.ward`}
                type="number"
                errorId={`ward`}
                min={1}
                register={register}
                error={errors}
                errorName="Ward Number"
                placeholder={placeholder[0]}
                label={<FormattedMessage id="ward" />}
                defaultValue={state?.[`${id}_physical_location_details`]?.ward}
                // required={true}
              />
              <FormError error={errors?.[`${id}_physical_location_details`]?.ward} />
            </>
          )}
        </FormattedMessage>
      </Col>
      <Col md="2">
        <FormattedMessage id="tole_placeholder">
          {(placeholder) => (
            <>
              <FormGroup
                id={`${id}_physical_location_details.tole`}
                type="text"
                register={register}
                errorId={`tole`}
                error={errors}
                errorName="Tole"
                placeholder={placeholder[0]}
                label={
                  condition ? <FormattedMessage id="location" /> : <FormattedMessage id="tole" />
                }
                defaultValue={state?.[`${id}_physical_location_details`]?.tole}
                // required={true}
              />
              <FormError error={errors?.[`${id}_physical_location_details`]?.tole} />
            </>
          )}
        </FormattedMessage>
      </Col>
    </Row>
  );
}

export default PhysicalLocationDetails;
